import { render } from "./ChangeUserAddressModal.vue?vue&type=template&id=5a81699b&scoped=true"
import script from "./ChangeUserAddressModal.vue?vue&type=script&lang=js"
export * from "./ChangeUserAddressModal.vue?vue&type=script&lang=js"

import "./ChangeUserAddressModal.vue?vue&type=style&index=0&id=5a81699b&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a81699b"]])

export default __exports__